<template>
    <div id="featuringmore">
        <div class="jumbotron">
            <div class="row">
                <div class="col" align="right">
                    <img class="profile-image mb-3 mb-lg-0 mb-lg-5 mr-md-0" src="../assets/images/products/audio2 2.jpg" alt="Avatar">
                </div>
                <div class="col" align="left">
                    <div class="product title">
                        <h1>ATH-CKX9iS</h1>
                        <h4>SonicFuel® In-ear Headphones with In-line Mic & Control</h4>
                        <span>US$79.95</span>
                    </div>
                    <a class="btn btn-success" href="https://www.bukalapak.com/p/hobi-koleksi/musik/sound-system-rekaman/2etbvf-jual-audio-technica-ath-ckx9is" role="button">Buy now</a>
                    <div class="product sub-title">
                        <h5>Overview</h5>

                        <p> Music is your energy for life – the fuel for your heart and soul.
                            SonicFuel® headphones are specifically designed for active, daily use, to power you forward by delivering extraordinary comfort, style and an immersive listening experience that never sounds artificial, processed or filtered.
                            Just pure sonic goodness for the high-octane tempo of your life.</p>
                        <p> The ATH-CKX9iS SonicFuel® in-ear headphones feature stay-in-place fit, providing unique comfort in addition to optimal sound.
                            The C-tip configuration nestles within the ear where it locks in place for extra stability.
                            Customize your comfort with a multitude of C-tip & silicone eartip sizes or use the included Comply™ foam eartips for true sonic immersion.</p>

                        <p>Large 13.5 mm performance-enhanced drivers fuel your day with a premium listening experience, deeper bass response and sparkling high frequencies.</p>

                        <p>In-line volume and microphone controls (on compatible smartphones) allow you to control music & phone calls without missing a beat.
                            A newly designed flat cable eliminates annoying tangles and lasts longer.
                            The included hard carrying case keeps your headphones protected and organized, so they are easy to find and unravel every time.</p>

                    </div>
                </div>
            </div>

            <div class="product description">
                <h5>Features</h5>
                <ul>
                    <li>Large 13.5 mm performance enhanced drivers offer a premium listening experience</li>
                    <li>C-tip design fits the shape of your ear for reliable stay-in-place comfort</li>
                    <li>In- line control with mic for answering/ending calls, controlling music & video playback, and controlling volume (on compatible smartphones & other portable devices)</li>
                    <li>Included luxury zippered hard carrying keeps headphones protected and easy to find every time</li>
                    <li>Also includes Comply™ foam tips, silicone eartips (XS/S/M/L), C-tips (S/M/L), and tangle-free flat cable</li>
                    <li>Available in black (BK) and silver (SV)</li>
                </ul>
            </div>

            <div class="product description">
                <h5>Specification</h5>
                <table class="table table-hover">
                    <tbody>
                    <tr class="table-primary">
                        <th scope="row">Type</th>
                        <td>Dynamic</td>
                    </tr>
                    <tr class="table-secondary">
                        <th scope="row">Driver Diameter</th>
                        <td>13.5 mm</td>
                    </tr>
                    <tr class="table-primary">
                        <th scope="row">Frequency Response</th>
                        <td>5 - 25,000 Hz</td>
                    </tr>
                    <tr class="table-secondary">
                        <th scope="row">Maximum Input Power</th>
                        <td>20 mW</td>
                    </tr>
                    <tr class="table-primary">
                        <th scope="row">Sensitivity</th>
                        <td>104 dB/mW</td>
                    </tr>
                    <tr class="table-secondary">
                        <th scope="row">Impendance</th>
                        <td>32 ohms</td>
                    </tr>
                    <tr class="table-primary">
                        <th scope="row">Weight</th>
                        <td>10 g (without cord)</td>
                    </tr>
                    <tr class="table-secondary">
                        <th scope="row">Cable</th>
                        <td>1.2 m (3.9'), Y-type</td>
                    </tr>
                    <tr class="table-primary">
                        <th scope="row">Connector</th>
                        <td>3.5 mm (1/8") gold-plated stereo 4-pin mini-plug, L-type</td>
                    </tr>
                    <tr class="table-secondary">
                        <th scope="row">Accessories Included</th>
                        <td>Hard carrying case, Comply™ foam eartip (M), silicone eartips (XS/S/M/L), C-tips (S/M/L)</td>
                    </tr>
                    <tr class="table-primary">
                        <th scope="row">Type (Microphone)</th>
                        <td>Condenser</td>
                    </tr>
                    <tr class="table-secondary">
                        <th scope="row">Sensitivity (Microphone)</th>
                        <td>-44 dB (0 dB=1 V/Pa, 1 kHz)</td>
                    </tr>
                    <tr class="table-primary">
                        <th scope="row">Frequency Response (Microphone)</th>
                        <td>100 - 10,000 Hz</td>
                    </tr>
                    <tr class="table-secondary">
                        <th scope="row">Polar Pattern (Microphone)</th>
                        <td>Omnidirectional</td>
                    </tr>
                    </tbody>
                </table>
            </div>

            <div class="product description">
                <h5>More Pictures</h5>
                <div class="row">
                    <div class="col-sm-4">
                        <img class="mb-3 mb-lg-0 mb-lg-5 mr-md-0" src="https://www.audio-technica.com/cms/resource_library/product_images/539779d8f1b87b22/med/ath_ckx9isbk_1_sq.jpg" alt="Avatar">
                    </div>
                    <div class="col-sm-4">
                        <img class="mb-3 mb-lg-0 mb-lg-5 mr-md-0" src="https://www.audio-technica.com/cms/resource_library/product_images/b90e9a9ad044155a/med/ath_ckx9issv_1_sq.jpg" alt="Avatar">
                    </div>
                    <div class="col-sm-4">
                        <img class="mb-3 mb-lg-0 mb-lg-5 mr-md-0" src="https://www.audio-technica.com/cms/resource_library/product_images/2d97ae3dc3deef99/med/ath_ckx9issv_2_sq.jpg" alt="Avatar">
                    </div>
                </div>
            </div>

            <MoreProducts/>

        </div>
    </div>
</template>

<script>
    import MoreProducts from "@/components/MoreProducts";
    export default {
        name: "FeaturingMore",
        components: {
            MoreProducts
        }
    }
</script>

<style lang="scss">
    #featuringmore {
        .btn {
            margin: 1.5rem;
        }
        .product {
            margin: 1.5rem;
        }
        .product.description {
            margin-top: 3rem;
            margin-left: 8rem;
            margin-right: 8rem;
        }
        .jumbotron {
            background-color: white;
        }
        .profile-image {
            width: auto;
            height: 40rem;
            object-fit: cover;
        }
        .row {
            margin: 2rem;
        }
    }
</style>
